import { tldExists } from 'tldjs';

export default {
  getMessage() {
    return 'Value must have a valid tld.';
  },
  validate(value) {
    const tld = value.split('.').pop();
    return new Promise((resolve) => {
      resolve({
        valid: tldExists(tld),
      });
    });
  },
};



// WEBPACK FOOTER //
// ./src/validators/tld.js